export default __webpack_public_path__ + "static/media/recruit.6b47041a.svg";